import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DriversService} from '../../drivers/drivers.service';
import {OnDemandDriversService} from '../../on-demand-drivers/on-demand-drivers.service';
import {DispatchService} from '../../dispatch/dispatch.service';
import {ReservationService} from '../reservations.service';
import {TripEditDriverVehicleComponent} from './trip-edit-driver-vehicle.component';
import {ProvidersService} from '../../providers/providers.service';
import {VehiclesService} from '../../vehicles/vehicles.service';
import {FormsModule} from '@angular/forms';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { DateRangeAvailableUpdateSoModule } from 'app/utils/date-range-available-update-so/date-range-available-update-so.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Trip2ThemeModule,
    DateRangeAvailableUpdateSoModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [TripEditDriverVehicleComponent],
    exports: [
        TripEditDriverVehicleComponent
    ],
    providers: [
        DriversService,
        OnDemandDriversService,
        DispatchService,
        ReservationService,
        ProvidersService,
        VehiclesService
    ]
})
export class TripEditDriverVehicleModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-edit-driver-vehicle/trip-edit-driver-vehicle.module.ts